module.exports = __webpack_public_path__ + "img/QiXie1.338f21a8.png";